// API Configuration
export const API_CONFIG = {
    BASE_URL: "https://alohacenterbe.cogweel.com/api/",
    // BASE_URL: "http://127.0.0.1:8000/api/",
    // BASE_URL: "http://192.168.1.27:8000/api/",
};

// Authentication Configuration
export const AUTH_CONFIG = {
    TOKEN_KEY: "auth_token",
    REFRESH_TOKEN_KEY: "refresh_token",
    TOKEN_EXPIRY: 60 * 60 * 1000, // 1 hour in milliseconds
};

// Date Format Configuration
export const DATE_FORMAT = "DD-MM-YYYY";

// File Upload Configuration
export const FILE_UPLOAD_CONFIG = {
    MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
    ALLOWED_FILE_TYPES: ["image/jpeg", "image/png", "image/gif"],
};